module.exports = __webpack_public_path__ + "static/bead-butt-door-c29009bc6bce075ea75bc9aed299682b.jpg";